import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { OldSolutionsFail } from '../components/OldSolutionsFail';
import { MechanismReveal } from '../components/MechanismReveal';
import { Benefits } from '../components/Benefits';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-forest/20" data-id="element-252">
      <main data-id="element-253">
        <Hero data-id="element-254" />
        <PainSection data-id="element-255" />
        <OldSolutionsFail data-id="element-256" />
        <MechanismReveal data-id="element-257" />
        <Benefits data-id="element-258" />
        <Pricing data-id="element-259" />
      </main>
      <Footer data-id="element-260" />
    </div>;
}